/**
 * usePhdTopologies - Manages topology list, loading, selection, and compare mode.
 */

import { useState, useEffect, useCallback } from 'react';
import { getTopologies } from '@vortx/shared-ui';

export function usePhdTopologies() {
    const [topologies, setTopologies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedTopologies, setSelectedTopologies] = useState([]);
    const [compareMode, setCompareMode] = useState(false);
    const [expandedId, setExpandedId] = useState(null);

    // Fetch topologies on mount
    useEffect(() => {
        const fetchTopologies = async () => {
            try {
                const data = await getTopologies();
                setTopologies(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchTopologies();
    }, []);

    const selectTopology = useCallback((topologies) => {
        setSelectedTopologies(topologies);
    }, []);

    const toggleCompareMode = useCallback(() => {
        setCompareMode(prev => !prev);
        setSelectedTopologies([]);
    }, []);

    const toggleExpanded = useCallback((topologyId) => {
        setExpandedId(prev => prev === topologyId ? null : topologyId);
    }, []);

    return {
        topologies,
        loading,
        error,
        selectedTopologies,
        compareMode,
        expandedId,
        selectTopology,
        toggleCompareMode,
        toggleExpanded,
        setSelectedTopologies,
    };
}
